import { pick } from 'lodash'

import { toLines } from '../../../../common/utils'

const foodMoodSimpleDetailsFormInitialValues = foodMood => ({
  ...pick(foodMood, [
    'description',
    'position',
    'synonyms',
    'isExcludedFromSearch',
    'isExcludedFromBrowsing',
  ]),
  synonyms: toLines(foodMood.synonyms),
})

export default foodMoodSimpleDetailsFormInitialValues
